'use client';

import i18next from 'i18next';
import { initReactI18next, useTranslation as useTranslationOrg } from 'react-i18next';
import { useCurrentLocale } from 'next-i18n-router/client';

import i18nConfig from './config';
import { i18nBackend, i18nBackendOptions, i18nSaveMissing } from './backend';

const runsOnServerSide = typeof window === 'undefined';

i18next
  .use(initReactI18next)
  .use(i18nBackend as never)
  .init({
    supportedLngs: i18nConfig.locales,
    lng: runsOnServerSide ? i18nConfig.defaultLocale : undefined,
    fallbackLng: false,
    defaultNS: false,
    detection: {
      order: ['path', 'htmlTag'],
    },
    ns: [],
    preload: [],
    backend: i18nBackendOptions,
    saveMissing: i18nSaveMissing,
  });

export function useClientTranslation(ns = 'common') {
  const locale = useCurrentLocale(i18nConfig);

  if (!i18next.options.ns?.includes(ns)) {
    i18next.loadNamespaces(ns);
  }

  if (!i18next.initializedLanguageOnce && !runsOnServerSide) {
    i18next.changeLanguage(locale);
    i18next.initializedLanguageOnce = true;
  }

  return useTranslationOrg(ns, { lng: locale });
}
